import { render, staticRenderFns } from "./BroadcastStationAssignMessage.vue?vue&type=template&id=96133c9c&scoped=true&"
import script from "./BroadcastStationAssignMessage.vue?vue&type=script&lang=js&"
export * from "./BroadcastStationAssignMessage.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastStationAssignMessage.vue?vue&type=style&index=0&id=96133c9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96133c9c",
  null
  
)

export default component.exports